import { isRon } from "../utility/common"

export const max_scores = {
	'level': 100,
	'chapter': 250,
	'all-chapters': 1000,
	'global': 10000
}

export const ron_chapters = ['',
	'Jade', 'Sand', 'Metal', 'Crystal', 'All Chapters'
]
export const ds_chapters = ['',
	'', 'Classic', 'Chaos', '', ''
]

export const chapters = isRon ? ron_chapters : ds_chapters

export const ranks = [
    'Novice',
    'Apprentice',
    'Adept',
    'Veteran',
    'Expert',
    'Master',
    'Grandmaster',
    'Inhuman',
    'Descendant'
]

export const ron_levels = [
	{
		id: 647,
		name: 'Ruins',
		chapter: 4,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 640,
		name: 'Penumbra',
		chapter: 4,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 670,
		name: 'Ascend',
		chapter: 4,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 637,
		name: 'Limbo',
		chapter: 4,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 147,
		name: 'Chamber',
		chapter: 4,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 341,
		name: 'Tower of Joy',
		chapter: 4,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 655,
		name: 'Crossfire',
		chapter: 4,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 426,
		name: 'Vertigo',
		chapter: 4,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 135,
		name: 'Hall of Despair',
		chapter: 4,
		is_secret: 0,
		has_secret: 1
	},
	{
		id: 158,
		name: 'Grinder',
		chapter: 4,
		is_secret: 0,
		has_secret: 1
	},
	{
		id: 192,
		name: 'Dismemberment',
		chapter: 4,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 365,
		name: 'Hope',
		chapter: 4,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 559,
		name: 'Bandicap',
		chapter: 4,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 171,
		name: 'Decay',
		chapter: 4,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 646,
		name: 'Surge',
		chapter: 4,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 619,
		name: 'Redshift',
		chapter: 3,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 625,
		name: 'Wall of Shear',
		chapter: 3,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 140,
		name: 'Elevator',
		chapter: 3,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 304,
		name: 'Hectic',
		chapter: 3,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 338,
		name: 'Zigzag',
		chapter: 3,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 144,
		name: 'Shaft',
		chapter: 3,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 318,
		name: 'Tunnel',
		chapter: 3,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 496,
		name: 'Terran Core',
		chapter: 3,
		is_secret: 0,
		has_secret: 1
	},
	{
		id: 333,
		name: 'Secure',
		chapter: 3,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 363,
		name: 'Protos',
		chapter: 3,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 353,
		name: 'Force',
		chapter: 3,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 36,
		name: 'Stalactites',
		chapter: 3,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 325,
		name: 'FTL',
		chapter: 3,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 616,
		name: 'Sunken Caves',
		chapter: 2,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 357,
		name: 'Couloir',
		chapter: 4,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 260,
		name: 'Bloodpit',
		chapter: 2,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 262,
		name: 'Redmire',
		chapter: 2,
		is_secret: 0,
		has_secret: 1
	},
	{
		id: 233,
		name: 'Pandora',
		chapter: 2,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 380,
		name: 'Flipflop',
		chapter: 2,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 202,
		name: 'Yard',
		chapter: 2,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 193,
		name: 'Sideswipe',
		chapter: 2,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 331,
		name: 'Buried',
		chapter: 2,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 635,
		name: 'Metamorphosis',
		chapter: 4,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 150,
		name: 'The Swing',
		chapter: 2,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 313,
		name: 'Gray Cliff',
		chapter: 2,
		is_secret: 0,
		has_secret: 1
	},
	{
		id: 121,
		name: 'Roundabout',
		chapter: 2,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 645,
		name: 'Oldway',
		chapter: 4,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 160,
		name: 'Palace',
		chapter: 2,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 488,
		name: 'Wish',
		chapter: 2,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 641,
		name: 'Techy',
		chapter: 3,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 156,
		name: 'Classy',
		chapter: 1,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 149,
		name: 'Plunge',
		chapter: 1,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 403,
		name: 'Trempe',
		chapter: 1,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 220,
		name: 'Breeze',
		chapter: 2,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 317,
		name: 'Corrosion',
		chapter: 2,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 414,
		name: 'Waste Pit',
		chapter: 1,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 420,
		name: 'Self Control',
		chapter: 1,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 642,
		name: 'Heretic',
		chapter: 4,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 157,
		name: 'The Gap',
		chapter: 1,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 404,
		name: 'Lush',
		chapter: 1,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 164,
		name: 'Potential',
		chapter: 1,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 190,
		name: 'Cliffside',
		chapter: 1,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 390,
		name: 'Spin',
		chapter: 2,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 487,
		name: 'Memorial',
		chapter: 1,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 408,
		name: 'Chasm',
		chapter: 1,
		is_secret: 0,
		has_secret: 1
	},
	{
		id: 463,
		name: 'Swishflush',
		chapter: 1,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 242,
		name: 'Razorback',
		chapter: 2,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 145,
		name: 'Shinespark',
		chapter: 1,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 348,
		name: 'Scanner',
		chapter: 3,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 154,
		name: 'Flea',
		chapter: 1,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 309,
		name: 'The Hill',
		chapter: 2,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 406,
		name: 'Sewers',
		chapter: 1,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 211,
		name: 'Vertical',
		chapter: 3,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 405,
		name: 'Wind Up',
		chapter: 1,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 143,
		name: 'Conduit',
		chapter: 1,
		is_secret: 0,
		has_secret: 1
	},
	{
		id: 336,
		name: 'Floodgate',
		chapter: 3,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 239,
		name: 'Splinter',
		chapter: 3,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 433,
		name: 'Soggy',
		chapter: 1,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 383,
		name: 'Ponddle',
		chapter: 1,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 243,
		name: 'Escape',
		chapter: 3,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 340,
		name: 'Plumber',
		chapter: 3,
		is_secret: 0,
		has_secret: 1
	},
	{
		id: 437,
		name: 'Threshold',
		chapter: 1,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 615,
		name: 'Mist',
		chapter: 2,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 227,
		name: 'Cube',
		chapter: 4,
		is_secret: 1,
		has_secret: 0
	},
	{
		id: 132,
		name: 'Void',
		chapter: 4,
		is_secret: 1,
		has_secret: 0
	},
	{
		id: 314,
		name: 'Boost',
		chapter: 3,
		is_secret: 1,
		has_secret: 0
	},
	{
		id: 376,
		name: 'Victim',
		chapter: 2,
		is_secret: 1,
		has_secret: 0
	},
	{
		id: 479,
		name: 'Detour',
		chapter: 4,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 188,
		name: 'Bolt',
		chapter: 2,
		is_secret: 1,
		has_secret: 0
	},
	{
		id: 238,
		name: 'Hadrian Wall',
		chapter: 2,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 432,
		name: 'A wet level name',
		chapter: 1,
		is_secret: 1,
		has_secret: 0
	},
	{
		id: 332,
		name: 'Rush',
		chapter: 3,
		is_secret: 1,
		has_secret: 0
	},
	{
		id: 429,
		name: 'Area 1',
		chapter: 1,
		is_secret: 1,
		has_secret: 0
	}
]

export const ds_levels = [
	{
		id: 1,
		name: 'Classic Original',
		chapter: 2,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 2,
		name: 'Classic Random',
		chapter: 2,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 3,
		name: 'Classic Weekly',
		chapter: 2,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 4,
		name: 'Chaos Original',
		chapter: 3,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 5,
		name: 'Chaos Random',
		chapter: 3,
		is_secret: 0,
		has_secret: 0
	},
	{
		id: 6,
		name: 'Chaos Weekly',
		chapter: 3,
		is_secret: 0,
		has_secret: 0
	},
]

export const levels = isRon ? ron_levels : ds_levels


// WEBPACK FOOTER //
// ./src/data/naezith.js